import React, { useState, useEffect } from 'react';

import { Grid, Typography } from "@material-ui/core";
import { withRouter, useHistory, useParams } from "react-router-dom";
import { connect } from 'react-redux';

import ClauseList from './ClauseList';
import TemplateView from './TemplateView';
import ClauseData from './ClauseData';
import { validateAccessControlResponse } from '../../utility/AbilityCheck'; // Import ability function
import { getDataModelById, getContractDataById, getSubModelData, clearReduxDataOfCurrentComponent, deleteContractPDFAction, updateDataModelData, createDocument, getModelData } from '../../store/actions';
import { Loader } from '../loader';

const WorkbookView = (props) => {
	const { id: _id } = useParams()
	const {isNewV1Theme} = props;
	const { chartData, chartUniqueId } = props.data
	const [tableData, setTableData] = useState([])
	const { pagination, subDataElement } = chartData
	let dataUniqueId = chartData.subDataModel
	let mainDataModelDataElement = props?.formData?.dataModel?.[dataUniqueId]?.mainDataModel?.dataElement

	const [isClauseView, setIsClauseView] = useState(false)
	const [allDataElementforClause, setAllDataElementsforClause] = useState({})
	const [isAccessControl, setIsAccessControl] = useState({
		error: false,
		message: "",
		code: ""
	});
	const [searchedText, setSearchedText] = useState('');
	const [loadPage, setLoadPage] = useState(false);

	const getRowsPerPage = () => {
		return Number(props.data.chartData?.pagination?.rowsPerPage) || 10;
	};

	const sharedJSON = {
		paginationPage: 0,
		count: 10,
		rowsPerPage: getRowsPerPage(),
		searchText: "",
		isSearchIconHide: false
	}

	const [state, setState] = useState({
		...sharedJSON
	})

	useEffect(() => {
		let dataUniqueId = chartData.subDataModel;
		let dataModelId = chartData.subDataModel
		if (!props.formData?.dataModel?.[dataUniqueId] && !props.formData[`${dataUniqueId}_loading}`]) {
			let payload = {
				appid: props.match.params.appid,
				orgId: props.appConfig?.org?._id,
				dataModelId: dataModelId,
				dataUniqueId: dataUniqueId
			};
			props.getDataModelById(payload);
		}
		fetchContractData()
	}, [])

	useEffect(() => {
		let dataUniqueId = chartData.subDataModel;
		const dataModelEntry = props?.formData?.dataModel?.[dataUniqueId];
		console.log("dataModelEntry", dataModelEntry);
		if (dataModelEntry?.mainDataModel) {
			fetchData();
		}
	}, [props?.formData?.dataModel, state.paginationPage, state.rowsPerPage, _id]);

	useEffect(() => {
		const res = props.formData.document[chartUniqueId + '_save'] || props.formData.document[chartUniqueId + '_update']
		if (res) {
			fetchData()
		}
		clearCurrentChartReduxStore();
	}, [props.formData?.document[chartUniqueId + '_save'], props.formData?.document[chartUniqueId + '_update']])

	const clearCurrentChartReduxStore = () => {
		let subKeys = [
			chartUniqueId + '_save',
			chartUniqueId + '_update'
		]
		props.clearReduxDataOfCurrentComponent({
			key: "document",
			subKey: subKeys
		})
	}

	const fetchData = (searchTextData) => {
		const payload = {
			appId: props.match.params.appid,
			dataModelId: chartData.subDataModel,
			dataUniqueId: chartUniqueId + "_data",
			fields: subDataElement?.map((i) => i.value).join(","),
			[mainDataModelDataElement]: _id
		}
		payload.page = state.paginationPage;
		payload.rowsPerPage = state.rowsPerPage;
		if (searchTextData !== undefined) {
			payload.search = searchTextData;
		} else if (searchedText) {
			payload.search = searchedText;
		}
		props.getSubModelData(payload)
	}

	// to get template data based on the Id
	const fetchContractData = () => {
		if (_id) {
			let payload = {
				id: _id,
				dataModelId: chartData.selectedDataModel,
				appId: props?.match?.params?.appid,
				fields: chartData.selectedDataElement.map(i => i.value).join(","),
				dataUniqueId: chartUniqueId + "_get",
			};
			props.getContractDataById(payload);
		}
	};

	useEffect(() => {
		if (props.formData?.document[chartUniqueId + "_data"]) {
			let data = props.formData?.document[chartUniqueId + "_data"];
			if (data && data?.data) {
				setTableData(data.data)
				// setLoadPage(true)
			}
			if (data && data.errorInfo) {
				validateAccessControlResponse(data.errorInfo, setIsAccessControl)
				// setNoData(true)
				// setErrorMsg(document?.[chartUniqueId + "data"]?.message)
			}
		}
	}, [props.formData?.document[chartUniqueId + "_data"]])

	useEffect(() => {
		let res = props.formData?.document[props.data?.chartUniqueId + '_get'];
		if (res?.data?.[0]) {
			let newState = res?.data?.[0] || {}
			setState((prevState) => ({
				...prevState,
				...newState
			}));
			// setLoadPage(true)
		}
		else if (res && res.errorInfo) {
			validateAccessControlResponse(res.errorInfo, setIsAccessControl)
			// setNoData(true)
			// setErrorMsg(document?.[chartUniqueId + "data"]?.message)
		}
	}, [props.formData?.document[props.data?.chartUniqueId + '_get']])

	useEffect(() => {
		console.log("tableData", tableData, state, _id)
		if (tableData?.length > 0 && state._id && _id) {
			setLoadPage(true)
		} else if (tableData?.length === 0 && !state._id && !_id) {
			setLoadPage(true)
		} else {
			setLoadPage(false)
		}
	}, [tableData, state.paginationPage, state.rowsPerPage, searchedText])
	return (
		isAccessControl.error ? <Typography variant="h6" style={{ color: 'red', textAlign: 'center', display: "flex", justifyContent: "center", alignItems: "center" }}>
			{isAccessControl.message ? isAccessControl.message : "You don't have enough permissions to access this page."}
		</Typography> :
			<div style={{ width: "100%" }}>
				{isClauseView &&
					<ClauseData
						{...props}
						isClauseView={isClauseView}
						setIsClauseView={setIsClauseView}
						allDataElementforClause={allDataElementforClause}
						setAllDataElementsforClause={setAllDataElementsforClause}
						isNewV1Theme={isNewV1Theme}
					/>
				}
				{!isClauseView &&
					<>
						<Grid>
							<TemplateView
								{...props}
								setIsClauseView={setIsClauseView}
								isAccessControl={isAccessControl}
								setIsAccessControl={setIsAccessControl}
								state={state}
								setState={setState}
								isNewV1Theme={isNewV1Theme}
							/>
							{_id &&
								<>
									<ClauseList
										{...props}
										isSearch={chartData.isSearch || false}
										isClauseView={isClauseView}
										setIsClauseView={setIsClauseView}
										isAccessControl={isAccessControl}
										setIsAccessControl={setIsAccessControl}
										allDataElementforClause={allDataElementforClause}
										setAllDataElementsforClause={setAllDataElementsforClause}

										setTableData={setTableData}
										tableData={tableData}
										state={state}
										setState={setState}
										sharedJSON={sharedJSON}
										setSearchedText={setSearchedText}
										searchedText={searchedText}
										isNewV1Theme={isNewV1Theme}
									/>
								</>
							}
						</Grid>
					</>
				}
			</div >
	);
}

const mapDispatchToProps = {
	getDataModelById,
	getContractDataById,
	getSubModelData,
	clearReduxDataOfCurrentComponent,
	createDocument,
	updateDataModelData,
	getModelData
}

const mapStateToProps = state => {
	return {
		formData: state.form,
	};
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(WorkbookView))

// export default WorkbookView{}